import { Component, Input } from '@angular/core';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { Order, OrdersService } from 'src/app/core/orders.service';
import { ERROR_ORDER_NOT_FOUND } from 'src/app/shared/constants/operationals';

@Component({
  selector: 'app-company-details-order-data',
  templateUrl: './company-details-order-data.component.html',
  styleUrls: ['./company-details-order-data.component.scss'],
})
export class CompanyDetailsOrderDataComponent {
  @Input() company_id?: string | null;
  orders?: Order[];
  is_read_running = true;

  constructor(private orders_service: OrdersService, private error_service: ErrorService) {}

  ngOnInit(): void {
    this.orders = [];
    if (this.company_id) this.listOrders(this.company_id);
  }

  onRefresh(): void {
    this.orders = [];
    if (this.company_id) this.listOrders(this.company_id);
  }

  listOrders(company_id?: string): void {
    this.is_read_running = true;

    if (company_id) {
      this.orders_service.listByCompanyID(company_id).subscribe({
        next: response => {
          this.orders = response.data;
          this.is_read_running = false;
        },
        error: error => {
          const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
          if (processed_error.code == ERROR_ORDER_NOT_FOUND) {
            this.orders = [];
          } else {
            this.error_service.processApiError(processed_error.code, processed_error.message);
          }
          this.is_read_running = false;
        },
      });
    }
  }
}
